export default {
  header: 'Opustiť stránku s neuloženými zmenami?',
  message: 'Opustením tejto stránky sa odstránia všetky neuložené zmeny.',
  leavePage: 'Opustiť stránku',
  stay: 'Zostať',
};
